import { createReduxEnhancer } from "@sentry/react";

const blacklistedSlicesOfState = [
  // Security
  "admin",
  "auth",
  "barcodeBadges",
  // Frontloader data (no privacy concerns but a lot of unneeded data for error reporting)
  "stains",
  "labStains",
  "labPanels",
  "externalLabs",
  "externalLabStains",
  "users",
  "labs",
  "accessionPrefixes",
  "labStations",
  "labClinics",
  "clinics",
];

const REMOVED = "REMOVED";

const createReduxEnhancerOptions: Parameters<typeof createReduxEnhancer>[0] = {
  actionTransformer: (action) => {
    return action;
  },
  stateTransformer: (state: any) => {
    const newState = { ...state };

    // Remove all blacklisted slices of state entirely
    blacklistedSlicesOfState.forEach((sliceOfState) => {
      if (newState.hasOwnProperty(sliceOfState))
        newState[sliceOfState] = REMOVED;
    });

    // Remove errors from requestStatuses slice-of-state
    if (newState.requestStatuses?.errors)
      newState.requestStatuses = {
        ...newState.requestStatuses,
        errors: REMOVED,
      };

    // Remove top-level patient objects
    if (newState.caseDetail?.patient)
      newState.caseDetail = { ...newState.caseDetail, patient: REMOVED };
    if (newState.case?.patient)
      newState.case = { ...newState.case, patient: REMOVED };
    if (newState.accession?.patient)
      newState.accession = { ...newState.accession, patient: REMOVED };

    // Remove nested patient objects from cases slice-of-state (viewer)
    if (newState.cases?.results && Array.isArray(newState.cases.results)) {
      newState.cases = {
        ...newState.cases,
        results: newState.cases.results.map((c: any) => {
          if (c.patient) return { ...c, patient: REMOVED };
          return c;
        }),
      };
    }

    // Remove nested patient objects from casesWithWork slice-of-state (lis)
    if (newState.casesWithWork) {
      const newCasesWithWork: any = {};
      Object.entries(newState.casesWithWork).forEach(
        ([id, c]: [string, any]) => {
          if (c.patient) {
            newCasesWithWork[id] = { ...c, patient: REMOVED };
          } else {
            newCasesWithWork[id] = c;
          }
        }
      );
      newState.casesWithWork = newCasesWithWork;
    }

    return newState;
  },
};

export default createReduxEnhancerOptions;
